import { Clock, Play, Square, Coffee } from 'lucide-react';
import { useClockIn } from '../hooks/useClockIn';
import { useState } from 'react';

export default function ClockInWidget() {
  const { status, loading, duration, clockIn, clockOut, startBreak, resumeWork } = useClockIn();
  const [showMenu, setShowMenu] = useState(false);

  const handleClockIn = async () => {
    const result = await clockIn();
    if (!result.success) {
      alert(result.error || 'Erro ao fazer clock-in');
    }
  };

  const handleClockOut = async () => {
    if (!confirm('Tem certeza que deseja fazer clock-out?')) return;
    const result = await clockOut();
    if (!result.success) {
      alert(result.error || 'Erro ao fazer clock-out');
    }
  };

  const handleBreak = async () => {
    const result = await startBreak('Pausa');
    if (!result.success) {
      alert(result.error || 'Erro ao iniciar pausa');
    }
    setShowMenu(false);
  };

  const handleResume = async () => {
    const result = await resumeWork();
    if (!result.success) {
      alert(result.error || 'Erro ao retomar trabalho');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-gray-500">
        <Clock className="h-5 w-5 animate-spin" />
        <span className="text-sm">Carregando...</span>
      </div>
    );
  }

  // Sem clock-in ativo
  if (!status) {
    return (
      <button
        onClick={handleClockIn}
        className="flex items-center gap-2 px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors"
      >
        <Play className="h-4 w-4" />
        <span className="text-sm font-medium">Iniciar Turno</span>
      </button>
    );
  }

  // Em pausa
  if (status.status === 'break') {
    return (
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 px-3 py-2 bg-yellow-100 text-yellow-800 rounded-md">
          <Coffee className="h-4 w-4" />
          <span className="text-sm font-medium">Em Pausa</span>
        </div>
        <button
          onClick={handleResume}
          className="px-3 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm"
        >
          Retomar
        </button>
      </div>
    );
  }

  // Clock-in ativo
  return (
    <div className="relative flex items-center gap-3">
      <div className="flex items-center gap-2 px-3 py-2 bg-green-100 text-green-800 rounded-md">
        <div className="flex items-center gap-2">
          <div className="h-2 w-2 bg-green-500 rounded-full animate-pulse"></div>
          <Clock className="h-4 w-4" />
          <span className="text-sm font-mono font-semibold">{duration}</span>
        </div>
      </div>

      <button
        onClick={() => setShowMenu(!showMenu)}
        className="px-3 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm font-medium"
      >
        Ações
      </button>

      {showMenu && (
        <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-xl border border-gray-200 z-50">
          <button
            onClick={handleBreak}
            className="w-full flex items-center gap-2 px-4 py-3 text-left hover:bg-gray-50 text-sm border-b border-gray-100"
          >
            <Coffee className="h-4 w-4 text-yellow-600" />
            <span>Iniciar Pausa</span>
          </button>
          <button
            onClick={handleClockOut}
            className="w-full flex items-center gap-2 px-4 py-3 text-left hover:bg-gray-50 text-sm text-red-600"
          >
            <Square className="h-4 w-4" />
            <span>Finalizar Turno</span>
          </button>
        </div>
      )}

      {/* Fechar menu ao clicar fora */}
      {showMenu && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setShowMenu(false)}
        />
      )}
    </div>
  );
}
